<main id="main-heading" role="main" tabindex="0" [@fadeInOut] class="container-fluid d-flex  main-heading-div">
  <div *ngIf="!error" id="modalTarget" #targetModal>
    <div class="col-sm-11 mx-auto d-flex flex-column">
      <div class="row" role="region" aria-label="File uploader"
        *ngIf="getPerClientPermission(permissionsConst.CanUploadFile)">
        <h1 tabindex="0" class="ps-3 mt-3">Upload File</h1>
        <div class="col-sm-12 top-space">
          <div class="col-md-12 no-left-padding">
            <div class="dropControl_wrapper">
              <div class="sample_wrapper text-center">
                <div class="dropArea_wrap col-sm-12" id="dropTarget">
                  <div class="font-icons">
                    <i class="fat fa-file-code"></i>
                    <i class="fat fa-file-excel"></i>
                  </div>
                  <h4 class="dropText" id="drop-box" tabindex="0">
                    Drag and drop files here to upload data<br />
                    <small class="dropText" tabindex="0">XML and XLSX formats only</small>
                  </h4>
                  <div id="droppingArea" aria-label="Drag and drop files here to upload data"
                    aria-describedby="drop-box">
                    <ejs-uploader #defaultupload id='fileupload' class="dropFiles" [dropArea]='dropElement'
                      [asyncSettings]='path' (uploading)='onFileUpload($event); addHeaders($event)'
                      (success)='onFileUploaded($event)' (failure)='onUploadFailure($event)'
                      [allowedExtensions]='allowExtensions' [minFileSize]='fileMinSize' [maxFileSize]='fileMaxSize'
                      tabindex="0">
                    </ejs-uploader>

                  </div>
                </div>
                <div class="top-space e-text-center">
                  <span id="drop">
                    <a class="btn btn-primary top-space" id="browse" (click)='browseClick($event)'
                      (keydown)='browseClick($event)' role="button" tabindex="0"
                      aria-label="Or select files from your desktop">Or select files from your desktop
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-10">
          <h1 tabindex="0" aria-label="Upload File History">Upload File History</h1>
          <p aria-label="The grid with uploaded files" id="grid-description" tabindex="0">
            All of the files listed below have been successfully uploaded to SingleSource. If you do not see a
            file name
            listed that you attempted to upload,
            the upload may have failed. Please try again. To determine if file data has been added to the
            SingleSource
            database, please consult the "Ingestion Status"
            indicator.
          </p>
        </div>
      </div>
      <div class="row pb-5" role="region" aria-label="Uploaded files grid">
        <div class="col-sm-12 top-space">
          <label tabindex="0" aria-label="Returned results counter">
            Results Returned:<span class="badge  warning-background badge-bottom-margin">{{recordCount}}</span> files
          </label>
          <div aria-describedby="grid-description">
            <app-fileuploadhistorygrid [gridData]="gridData" [appDefaults]="appDefaults"
              (messageEvent)="receiveMessage($event)" tabindex="0">
            </app-fileuploadhistorygrid>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="error">
    <h2>{{error}}</h2>
  </div>
</main>
<ejs-dialog id="modalDialog" #modalDialog [isModal]='isModal' [header]='modalHeader' [target]='target'
  [width]='modalWidth' [buttons]='buttons' [animationSettings]='animationSettings' [content]='modalContent'
  [visible]='hidden' aria-hidden="true" aria-haspopup="true">
</ejs-dialog>
